import queryString from 'query-string';
import env from 'pages/MyAccount/utils/env';
import { flattenProducts } from '@fff-web/fff-cart';
import { getCampaignType, campaignId } from 'pages/MyAccount/utils/campaign';
import request from './request';
import requestJson from './requestJson';

export function requestProducts(offset, selectedCategoryId, sort, shareUrl) {
  const type = getCampaignType();
  let requestUrl = `${env.aceApi}api/1/campaigns/products?type=${type}&orderBy=${sort}`;
  if (offset !== null) {
    requestUrl += `&offset=${offset}&limit=24`;
  }
  if (selectedCategoryId !== null) {
    requestUrl += `&categoryId=${selectedCategoryId}`;
  }
  if (shareUrl !== null) {
    requestUrl += `&extraProductShareUrl=${shareUrl}`;
  }
  if (campaignId !== null) {
    requestUrl += `&campaignId=${campaignId}`;
  }
  return request(requestUrl);
}

export function requestFavoriteProducts(sort) {
  const type = getCampaignType();
  let requestUrl = `${env.aceApi}api/1/favorites/products?type=${type}&orderBy=${sort}`;
  if (campaignId !== null) {
    requestUrl += `&campaignId=${campaignId}`;
  }
  return request(requestUrl);
}

export async function getProductsById(productIds) {
  const type = getCampaignType();
  const queryParams = {
    type,
  };
  if (campaignId) {
    queryParams.campaignId = campaignId;
  }
  const requestUrl = `${env.aceApi}api/1/campaigns/products?${queryString.stringify(queryParams)}`;
  const response = await request(
    requestUrl,
    'POST',
    { 'Content-Type': 'application/json' },
    JSON.stringify(productIds),
  );
  const {
    products: productsWithVariants,
    productIds: responseIds,
    totalProductCount,
  } = response.value;
  const { products, variants } = flattenProducts(productsWithVariants);
  return {
    productIds: responseIds,
    products,
    variants,
    totalProductCount,
  };
}

export async function getProducts(
  offset: number | null,
  selectedCategoryId: string | null,
  sort: Sort,
  shareUrl: string | null,
) {
  const productResponse = await requestProducts(offset, selectedCategoryId, sort, shareUrl);
  const { products: productsWithVariants, productIds, totalProductCount } = productResponse.value;
  const { products, variants } = flattenProducts(productsWithVariants);

  return {
    productIds,
    products,
    variants,
    totalProductCount,
  };
}

export async function getBestSellingProducts(
  selectedCategoryId,
  shareUrl,
  selectedSort,
  productRecAbKey,
) {
  const campaignType = getCampaignType();
  const queryParams = {
    campaignType,
    offset: 0,
    orderBy: selectedSort,
    limit: 24,
    abTestKey: productRecAbKey,
  };
  if (campaignId) {
    queryParams.campaignId = campaignId;
  }
  if (selectedCategoryId) {
    queryParams.categoryId = selectedCategoryId;
  }
  if (shareUrl) {
    queryParams.extraProductShareUrl = shareUrl;
  }
  const url = `${env.aceApi}api/1/products?${queryString.stringify(queryParams)}`;
  const headers = {
    Accept: 'application/vnd.fabfitfun.v3+json',
  };
  const response = await request(url, 'GET', headers);
  const {
    data: { items },
  } = response;
  const {
    products: productsWithVariants,
    totalProductCount,
    productIds,
    sortedProductIds,
  } = items[0];
  const { products, variants } = flattenProducts(productsWithVariants);
  return {
    productIds,
    sortedProductIds,
    totalProductCount,
    products,
    variants,
  };
}

export async function getFavoriteProducts(sort) {
  const productResponse = await requestFavoriteProducts(sort);
  const { products: productsWithVariants, productIds, totalProductCount } = productResponse;
  const { products, variants } = flattenProducts(productsWithVariants);
  return {
    productIds,
    products,
    variants,
    totalProductCount,
  };
}

function requestSponsoredProducts() {
  const type = getCampaignType();
  let requestUrl = `${env.aceApi}api/1/campaigns/products?type=${type}&isSponsored=true`;

  if (campaignId !== null) {
    requestUrl += `&campaignId=${campaignId}`;
  }

  return request(requestUrl);
}

export async function getSponsoredProducts() {
  const productResponse = await requestSponsoredProducts();
  const { products: productsWithVariants, productIds, totalProductCount } = productResponse.value;
  const { products, variants } = flattenProducts(productsWithVariants);

  return {
    productIds,
    products,
    variants,
    totalProductCount,
  };
}

export const getProductById = (productId) => request(`${env.aceApi}api/1/products/${productId}`);

export function getFavoritesData() {
  const type = getCampaignType();
  let requestUrl = `${env.aceApi}api/1/favorites/products/ids?type=${type}`;
  if (campaignId !== null) {
    requestUrl += `&campaignId=${campaignId}`;
  }
  return request(requestUrl);
}

export function updateFavorite(campaignIdNumber, productId, liked) {
  const requestUrl = `${
    env.aceApi
  }api/1/favorites/campaigns/${campaignIdNumber}/products/${productId}/likes?isLike=${
    liked ? 'true' : 'false'
  }`;
  return request(requestUrl, 'PUT');
}

export const getProductsByCampaignType = (campaignType, auth) => {
  const type = getCampaignType();
  const headers = { Accept: 'application/vnd.fabfitfun.v3+json' };
  const requestUrl = `${env.aceApi}api/1/products?campaignType=${campaignType || type}`;
  return requestJson(requestUrl, 'GET', headers);
};
